/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M64.945 87.184c.83.155 1.583.18 2.257.09a9.679 9.679 0 01-.454-2.814c-.09-1.426-1.077-17.063-1.881-26.879-2.011 9.983-4.139 22.96-4.139 22.96-.649 3.2 1.401 6.117 4.217 6.643zM49.104 54.163c-1.272.32-2.543.616-3.75.873l.584 15.188h-20.85l.544-14.327c0-3.546 1.142-5.268 3.867-5.692a7.306 7.306 0 01.156-3.816c-5.06.476-7.824 3.79-7.824 9.431l-1.012 26.443c-1.687.668-2.88 2.287-2.88 4.201 0 2.506 2.05 4.536 4.58 4.536 2.53 0 4.58-2.03 4.58-4.536 0-1.747-1.012-3.25-2.479-4.008l.312-8.468h21.136l.519 13.825a1.87 1.87 0 001.972 1.812 1.89 1.89 0 001.83-1.953l-1.285-33.51z"
    ></path>
    <path
      fill="#B92A2E"
      d="M38.945 52.352c3.452-.54 13.053-2.416 17.05-4.485 1.452-.758 1.699-1.118 2.348-2.762.493-1.246.856-3.264 1.595-5.422 0 0 8.175 11.512 8.37 13.414.881 9.148 2.27 31.222 2.27 31.222 0 3.238 2.556 5.692 5.397 5.692h.052c3.36-.026 5.19-1.837 5.501-5.152l.948-29.167c.09-6.27.337-9.765-2.608-16.19-4.775-10.407-12.884-19.516-20.487-19.58-4.918-.04-7.889 3.918-8.953 9.16-.713 3.483-1.96 10.434-1.96 10.434s-9.536 3.816-11.884 4.754c-1.972.783-3.931 2.634-3.347 5.14.648 2.864 3.243 3.327 5.708 2.942zM50.92 19.1c0 5.575-4.567 10.098-10.198 10.098-5.632 0-10.199-4.523-10.199-10.099C30.523 13.523 35.09 9 40.722 9c5.63 0 10.198 4.523 10.198 10.1z"
    ></path>
  </Svg>
)

export default Icon
